import { Box, Button, Stack, Typography } from "@mui/material";
import React, { useState } from "react";
import styles from "../../styles/pages/superadmin/message-details.module.scss";
// import styles from "../../styles/pages/mymessage.module.scss";
import PerfectScrollbar from "react-perfect-scrollbar";
import "react-perfect-scrollbar/dist/css/styles.css";
import MessageTypeBox from "../MessageTypeBox/MessageTypeBox";
import MessageBoxEven, { IFile } from "../MessageBoxEven/MessageBoxEven";
import assest from "../../json/assest";
import useFetch from "../../hooks/api/useFetch";
import { getStyledDateTime } from "../../lib/functions/utils.lib";

const MessageDetailsRightPanel = (props) => {
  const {
    data: messages,
    isError,
    isLoading,
    isSuccess,
    refetch,
  } = useFetch(
    ["inquiry-meassages", props?.inquiry?.id],
    `inquiry/${props?.inquiry?.id}/messages
        `
  );
  console.warn(props?.inquiry?.id);
  const [joinConvo, setJoinConvo] = useState(false);
  const getStatus = (inquiry) => {
    if (!inquiry?.status) {
      if (inquiry?.initiated?.name === inquiry?.last_message?.sender?.name)
        return "Need your reply";
      return "Pending";
    }
    return "Resolved";
  };

  const { onScroll, id } = props;
  // const { scroll2 } = props;

  return (
    <Box className={`${styles.detailsColRight}`}>
      {/* <PerfectScrollbar className={`${styles.scrollbarDetails} ${styles.detailsColRight}`} id={id}
         onScroll={onScroll}> */}
      <Box className={styles.innerColRight}>
        <Box className={styles.messageBoxWrapper}>
          {props.inquiry?.admin_joined || props?.inquiry?.archive ? (
            props?.status?.name === "Resolved" ||
            props?.status?.name === "Closed" ? (
              <Box className={styles.filterBg}>
                <Stack
                  direction="row"
                  flexWrap="wrap"
                  alignItems="center"
                  className={styles.respond}
                >
                  <Button
                    className={`${styles.primaryBlackBtn} ${
                      props?.status?.name === "Resolved" ||
                      props?.status?.name === "Closed"
                        ? `${styles.openagainBtn}`
                        : ""
                    }`}
                    onClick={props?.open_inquiry}
                  >
                    Open Again
                  </Button>
                </Stack>
              </Box>
            ) : !props?.respondToInquiry ? (
              <Box className={styles.filterBg}>
                <Stack
                  direction="row"
                  flexWrap="wrap"
                  alignItems="center"
                  className={styles.respond}
                >
                  <Button
                    className={styles.primaryBlackBtn}
                    onClick={props?.toggleRepondToInquiry}
                  >
                    Respond
                  </Button>
                  <Button
                    className={`${styles.markReslvBtn}`}
                    onClick={props?.resolve_inquiry}
                  >
                    Mark as <strong>resolved</strong>
                  </Button>
                </Stack>
              </Box>
            ) : (
              ""
            )
          ) : props?.inquiry?.video ? (
            <Box className={styles.filterBg}>
              <Stack
                direction="row"
                flexWrap="wrap"
                alignItems="center"
                flexDirection="row-reverse"
                justifyContent="space-between"
                className={`${styles.respond} ${styles.joinConvo}`}
              >
                <Button
                  className={styles.primaryBlackBtn}
                  onClick={props.admin_join}
                >
                  <strong>Join</strong> this convo
                </Button>
                <Typography variant="caption">
                  You are not a part of this conversation
                </Typography>
              </Stack>
            </Box>
          ) : !props?.respondToInquiry ? (
            <Box className={styles.filterBg}>
              <Stack
                direction="row"
                flexWrap="wrap"
                alignItems="center"
                className={styles.respond}
              >
                <Button
                  className={styles.primaryBlackBtn}
                  onClick={props?.toggleRepondToInquiry}
                >
                  Respond
                </Button>
                <Button
                  className={`${styles.markReslvBtn}`}
                  onClick={props?.resolve_inquiry}
                >
                  Mark as <strong>resolved</strong>
                </Button>
              </Stack>
            </Box>
          ) : (
            ""
          )}
          {props?.respondToInquiry ? (
            <MessageTypeBox
              inquiry={props.inquiry}
              refreshMessages={refetch}
              toggleRepondToInquiry={props?.toggleRepondToInquiry}
            />
          ) : (
            ""
          )}
          {/* <PerfectScrollbar
            className={`${styles.scrollbarDetailsRight}`}
            id={id}
            onScroll={onScroll}
          > */}
          <Box
            className={styles.scrollbarDetailsRight}
            // id={id}
            // onScroll={onScroll}
          >
            <Box
              className={`${styles.evenMsgList} ${
                props?.respondToInquiry ? `${styles.respondOpen}` : ""
              }`}
            >
              {messages?.data?.data?.map((item, index) => {
                return (
                  <MessageBoxEven
                    key={index}
                    pfAvatar={item?.sender.image}
                    pfName={item?.sender.name}
                    designation={
                      item?.sender?.role?.display_name
                        ? item?.sender?.role?.display_name
                        : "N/A"
                    }
                    postedDate={getStyledDateTime(item?.created)}
                    msgContent={item?.message}
                    type={item?.type}
                    attachFile={item?.attachments}
                  />
                );
              })}
            </Box>
          </Box>
          {/* </PerfectScrollbar> */}
        </Box>
      </Box>
      {/* </PerfectScrollbar> */}
    </Box>
  );
};

export default MessageDetailsRightPanel;
